export { postJejuCancelConsult } from './postJejuCancelConsult';

export { fetchJejuApplyList } from './fetchJejuApplyList';
export { fetchJejuCommon } from './fetchJejuCommon';
export { fetchJejuTermList } from './fetchJejuTermList';
export { fetchJejuSchedule, type ScheduleDetail } from './fetchJejuSchedule';

export { postJejuApply } from './postJejuApply';
